/**
 * @file 官方流程权限相关
 */

export default {
    hasShowOfficialBoard(state, getters) {
        return getters.hasOfficialPermission
            && state.topicData.ext
            && state.topicData.ext.qaOfficialInfo
            && Object.keys(state.topicData.ext.qaOfficialInfo).length;
    },
    followUserName(state) {
        return Object.keys(state.topicData.ext.qaOfficialInfo.followUserInfo).length
            ? state.topicData.ext.qaOfficialInfo.followUserInfo.nickname
            : '无';
    },
    auditUserName(state) {
        return Object.keys(state.topicData.ext.qaOfficialInfo.auditUserInfo).length
            ? state.topicData.ext.qaOfficialInfo.auditUserInfo.nickname
            : '无';
    },
    isLostOfficial(state, getters) {
        if ((!getters.hasSystemPermission) && (!getters.hasQaAdminPermission)) {
            if (state.topicData.ext.qaOfficialInfo.isAudit && (!getters.hasDevelopPermission)) {
                state.lostOfficialUser
                    = state.topicData.ext.qaOfficialInfo.auditUserInfo.nickname
                    + '：您的审核人';
                return true;
            }
            if (state.topicData.ext.qaOfficialInfo.isFollower && (!getters.hasSupportPermission)) {
                state.lostOfficialUser
                    = state.topicData.ext.qaOfficialInfo.followUserInfo.nickname
                    + '：您的跟进人';
                return true;
            }
        }
        return false;
    },
    canOperateOfficial(state, getters) {
        // 是否可操作官方流程
        // 未完结态
        // 已分配人员：技术支持人员为跟进人 or 问题管理员 or 管理员
        if ((!getters.isClosed) && Object.keys(state.topicData.ext.qaOfficialInfo.followUserInfo).length) {
            if (getters.hasSystemPermission
                || getters.hasQaAdminPermission
                || (getters.hasSupportPermission
                    && state.topicData.ext.qaOfficialInfo.isFollower)) {
                return true;
            }
        }
        // 未完结态
        // 未分配人员：除rd审核人的所有管理角色
        // 完结态：除rd审核人的所有管理角色
        else if (getters.hasSystemPermission
                || getters.hasQaAdminPermission
                || getters.hasSupportPermission) {
            return true;
        }
        return false;
    },
    hasAnswerPlaceHolder(state) {
        return state.topicData.ext.qaOfficialInfo.questionCategory === 1
            && (!state.topicData.ext.qaOfficialInfo.answerContent.length);
    },
    answerPlaceHolder(state, getters) {
        if (getters.hasAnswerPlaceHolder) {
            return state.OfficialBoardLabel.AnswerContent.placeholder[state.topicData.ext.qaOfficialInfo.questionType];
        }
        return '';
    },
    canSetRelatedIssue(state) {
        // 允许设置关联issue的出现条件
        // 状态为'待解决' && 类型为bug/需求
        return state.topicData.ext.qaOfficialInfo.questionCategory === 1
            && state.topicData.ext.qaOfficialInfo.questionType !== 3;
    },
    canSetAnswerReply(state) {
        // 不允许设置回复话术的出现条件
        // 状态为'新建'
        // 状态为'待解决' && 类型为bug/需求,但是没有勾选'不设置'关联issue，却没有设置关联issue
        return !(state.topicData.ext.qaOfficialInfo.process === 'OP_ACTIVED'
            || (state.topicData.ext.qaOfficialInfo.process === 'OP_PENDING_FIXED'
            && state.topicData.ext.qaOfficialInfo.questionType !== 3
            && (!state.isCheckedNotRelatedIssue
                && !state.topicData.ext.qaOfficialInfo.issueList.length)));
    },
    canSubmitAudit(state) {
        // 最终提交审核出现条件
        // 状态不为“新建”
        // 若为bug/需求还需设置关联issue
        // 回复话术已设置不为空
        if (state.topicData.ext.qaOfficialInfo.process === 'OP_ACTIVED') {
            return false;
        }
        if (state.topicData.ext.qaOfficialInfo.questionCategory === 1
            && state.topicData.ext.qaOfficialInfo.questionType !== 3
            && state.topicData.ext.qaOfficialInfo.issueList.length === 0
            && (!state.isCheckedNotRelatedIssue)) {
            return false;
        }
        if (!state.topicData.ext.qaOfficialInfo.answerContent.length) {
            return false;
        }
        return true;
    },
    isAuditPending(state) {
        // 待审核状态
        return state.topicData.ext.qaOfficialInfo.process === 'OP_AUDIT_PENDING';
    },
    isActiveWithoutFollower(state, getters) {
        // 新建无跟进人
        return state.topicData.ext.qaOfficialInfo.process === 'OP_ACTIVED'
            && getters.followUserName === '无';
    },
    isClosed(state) {
        // 已关闭状态
        return state.topicData.ext.qaOfficialInfo.process === 'OP_CLOSED';
    },
    submitOperationTip(state, getters) {
        return getters.isAuditPending ? '取消审核' : '提交审核';
    },
    canAudit(state, getters) {
        // 允许审核的出现条件
        // 状态为'待审核' && 操作人为审核员且 or 问题管理员 or 管理员
        return getters.isAuditPending
            && (getters.hasSystemPermission
            || getters.hasQaAdminPermission
            || (getters.hasDevelopPermission
                && state.topicData.ext.qaOfficialInfo.isAudit));
    },
    // 问题状态选项更改未保存
    dontSaveQuestion(state) {
        return state.selectedQuestionCategory !== state.topicData.ext.qaOfficialInfo.questionCategory
            || state.selectedQuestionType !== state.topicData.ext.qaOfficialInfo.questionType
            || state.selectedBugLevel !== state.topicData.ext.qaOfficialInfo.questionLevel
            || state.selectedQuestionTag !== state.topicData.ext.qaOfficialInfo.questionTag;
    },
    // 是否在确认问题的bug分类下
    isBug(state) {
        return state.selectedQuestionCategory === 1
            && state.selectedQuestionType === 1;
    },
    // 是否未设置关联issue
    hasNotRelatedIssue(state) {
        return state.selectedQuestionCategory === 1
            && state.selectedQuestionType !== 3
            && state.topicData.ext.qaOfficialInfo.issueList.length === 0
            && (!state.isCheckedNotRelatedIssue);
    },
    canChangeIssueProcess(state, getters) {
        // 允许更改issue状态：管理员，问题管理员，rd跟进人
        return getters.hasSystemPermission
            || getters.hasQaAdminPermission
            || getters.hasSupportPermission
            || (getters.hasDevelopPermission
                && state.topicData.ext.issueOfficialInfo.isFollower);
    },
    issueProcessOptions(state) {
        return state.issueBugProcessOptions;
    }
};
